import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import supabase from "../config/supabaseClient";
import { useYear } from "../YearContext"; // adjust path if needed

const AssignYear = () => {
  const { player_id } = useParams();
  const navigate = useNavigate();
  const { year } = useYear(); // get current selected year from context

  const [year_id, setYear_id] = useState(null);
  const [group_id, setGroup_id] = useState('');
  const [groups, setGroups] = useState([]);
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get year_id for the current year from DB
        const { data: yearData, error: yearError } = await supabase
          .from("year")
          .select("id")
          .eq("year", year)
          .single();

        if (yearError) throw yearError;
        setYear_id(yearData?.id);

        // Fetch available groups
        const { data: groupsData, error: groupsError } = await supabase
          .from("groups")
          .select("id, name");

        if (groupsError) throw groupsError;
        setGroups(groupsData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setFormError("Error loading data.");
      }
    };

    fetchData();
  }, [year]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!player_id || !year_id || !group_id) {
      setFormError("Missing year or group selection.");
      return;
    }

    try {
      const { error } = await supabase
        .from("players_year")
        .insert([{ player_id, year_id, group_id }]);

      if (error) {
        console.error("Supabase error:", error);
        setFormError("Error assigning player. " + (error.message || "Unknown error"));
      } else {
        setFormError(null);
        navigate("/players", { replace: true });
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      setFormError("Unexpected error occurred. " + (err.message || "Unknown error"));
    }
  };

  return (
    <div className="page assign">
      <h2>Assign Player to {year} & Group</h2>
      <form onSubmit={handleSubmit}>
        {/* Show year from context (not editable) */}
        <p><strong>Year:</strong> {year}</p>

        <label htmlFor="group_id">Group:</label>
        <select
          id="group_id"
          value={group_id}
          onChange={(e) => setGroup_id(e.target.value)}
        >
          <option value="">Select a group</option>
          {groups.map((group) => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <button>Assign</button>

        {formError && <p className="error">{formError}</p>}
      </form>
    </div>
  );
};

export default AssignYear;
